import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const surveysRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "surveys",
}).lazy(() => import("./index.lazy").then((d) => d.Route));
